// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 767.98px) {
  .container-fluid {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.span_page-title-text {
  font-weight: bold;
  font-size: 1.4rem;
  align-items: center;
  align-self: center;
}

.ul_nav-header .icon-bell {
  font-size: 1.1rem;
  vertical-align: bottom;
}
.ul_nav-header .img_header-img {
  width: 35px;
  height: 35px;
  margin: 0 10px;
  border-radius: 50em;
}
.ul_nav-header .a_page-title {
  display: flex;
}
.ul_nav-header .a_page-title .img_page-title-icon {
  margin-right: 10px;
  margin-left: 20px;
  font-size: 24px;
}

@media (max-width: 767.98px) {
  :host ::ng-deep .navbar-brand {
    left: 7rem !important;
  }
}
:host ::ng-deep .app-header .navbar-toggler {
  border: none !important;
  box-shadow: none;
}

@media (max-width: 767.98px) {
  :host ::ng-deep .app-header button:last-of-type {
    display: none;
  }
  :host ::ng-deep .app-header .navbar-toggler {
    z-index: 1;
  }
  :host ::ng-deep app-header {
    position: fixed;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
